import { render, staticRenderFns } from "./StayRecord.vue?vue&type=template&id=916fd330&scoped=true&"
import script from "./StayRecord.vue?vue&type=script&lang=js&"
export * from "./StayRecord.vue?vue&type=script&lang=js&"
import style0 from "./StayRecord.vue?vue&type=style&index=0&id=916fd330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916fd330",
  null
  
)

export default component.exports